import {Component, Input, OnChanges} from '@angular/core';
import {UserResponse} from '../../../../../../@shared/models/response.module';
import {UserService} from '../../../../../../@core/services/user.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {USM_USR_16, USM_USR_3} from '../../../../../../@shared/models/input.module';

@Component({
  selector: 'app-edit-user-profile',
  standalone: false,
  templateUrl: './edit-user-profile.html',
  styleUrl: './edit-user-profile.css'
})
export class EditUserProfile implements OnChanges{
  @Input() user: UserResponse
  profileImage: File | null

  constructor(private userService: UserService,
              private modal: NgbActiveModal) {
  }

  ngOnInit() {
    if (this.user) {
      this.user.date_of_birth = fromApiDate(this.user.date_of_birth);
    }
  }

  ngOnChanges(SimpleChanges: any){
    if (this.user) {
      this.user.date_of_birth = fromApiDate(this.user.date_of_birth);
    }
  }

  saveProfile(){
    let params: USM_USR_3 = {
      user_id: this.user.user_id,
      first_name: this.user.first_name,
      last_name: this.user.last_name,
      email: this.user.email,
      phone: this.user.phone,
      date_of_birth: this.toISO(this.user.date_of_birth) ? this.user.date_of_birth : null,
      riding_club: this.user.riding_club ? this.user.riding_club : null,
      country: this.user.country ? this.user.country : null,
      address: this.user.address ? this.user.address : null,
      city: this.user.city ? this.user.city : null,
      state: this.user.state ? this.user.state : null,
      zip_code: this.user.zip_code ? this.user.zip_code : null
    }

    this.userService.updateUser(params).subscribe((res) => {
      this.user = res

      if (this.profileImage) {
        let params: USM_USR_16 = {
          image: this.profileImage
        }
        this.userService.updateProfileImage(params).subscribe((res) => {
          this.user = res
          this.modal.close(this.user)
        })
      }
      else {
        this.modal.close(this.user)
      }
    })
  }

  private toISO(date: string): string {
    if (!date) return '';
    // Handle full ISO strings (2025-10-12T00:00:00.000Z)
    if (date.includes('T')) {
      return date.split('T')[0]; // → "2025-10-12"
    }
    // Already YYYY-MM-DD (from input type="date")
    return date;
  }
}

function fromApiDate(v?: string | null): string {
  if (!v) return ''; // always return a string
  try {
    const parsed = new Date(v);
    if (isNaN(parsed.getTime())) {
      const [datePart] = v.split(',');
      const [month, day, year] = datePart.split('/').map(x => x.trim());
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    const y = parsed.getFullYear();
    const m = String(parsed.getMonth() + 1).padStart(2, '0');
    const d = String(parsed.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  } catch {
    return '';
  }
}
